import { p as proxyCustomElement, H, h, a as Host } from './index.js';

const progressBarCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:flex;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host([type=linear]){background-color:var(--jw-theme-neutral-muted-message-bg-color);border-radius:624.9375rem;height:.5rem;overflow:hidden;position:relative}:host([type=linear]) .linear-fill{border-radius:624.9375rem;height:.5rem;transition:width .2s ease-in-out;width:100%}:host([type=linear]) .linear-fill.regular{background-color:var(--jw-theme-system-primary-default-bg-color)}:host([type=linear]) .linear-fill.warning{background-color:var(--jw-theme-warning-primary-default-bg-color)}:host([type=linear]) .linear-fill.error{background-color:var(--jw-theme-error-primary-default-bg-color)}:host([type=linear][indeterminate]) .linear-fill{animation:uh93wp6 1.3s linear infinite alternate;height:.5rem;position:absolute;transition:none;width:30%}@keyframes uh93wp6{0%{left:0}to{left:70%}}:host([type=circular]){height:24px;width:24px}:host([type=circular]) .circle-background{stroke:var(--jw-theme-neutral-muted-message-bg-color)}:host([type=circular]) .circle-background,:host([type=circular]) .circle-progress{fill:none}:host([type=circular]) .circle-progress{transition:all .2s ease-in-out;stroke-linecap:round;stroke-linejoin:round}:host([type=circular]) .circle-progress.regular{stroke:var(--jw-theme-system-primary-default-bg-color)}:host([type=circular]) .circle-progress.warning{stroke:var(--jw-theme-warning-primary-default-bg-color)}:host([type=circular]) .circle-progress.error{stroke:var(--jw-theme-error-primary-default-bg-color)}:host([type=circular][indeterminate]) svg{animation:uh93wqx 1.5s linear infinite}@keyframes uh93wqx{to{transform:rotate(1turn)}}:host([type=circular][indeterminate]) svg .circle-progress{animation:uh93wrv 2s ease-in-out infinite}@keyframes uh93wrv{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-45}to{stroke-dasharray:90,150;stroke-dashoffset:-60}}";

const WuiProgressBar = /*@__PURE__*/ proxyCustomElement(class WuiProgressBar extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Determines bar or circular form
         */
        this.type = 'linear';
        /**
         * Progressvalue 0-1
         */
        this.progressValue = 0;
        /**
         * If progress value is unknown
         */
        this.indeterminate = false;
        /**
         * Progress bar background color
         */
        this.progressBackground = 'regular';
        this.getSvgProperties = (percentage) => {
            const sqSize = 24;
            const strokeWidth = 4;
            const radius = (sqSize - strokeWidth) / 2;
            const viewBox = `0 0 ${sqSize} ${sqSize}`;
            const dashArray = radius * Math.PI * 2;
            const dashOffset = dashArray - (dashArray * percentage) / 100;
            const resetOffset = percentage <= 10 ? dashOffset : dashOffset + strokeWidth / 2;
            return {
                sqSize,
                strokeWidth,
                radius,
                viewBox,
                dashArray,
                resetOffset,
            };
        };
    }
    render() {
        let progressValue = typeof this.progressValue === 'undefined' ? 0 : this.progressValue;
        // Sanity check
        if (progressValue > 1) {
            progressValue = 1;
        }
        const percentage = Math.round(progressValue * 100);
        const width = !this.indeterminate ? { width: `${percentage}%` } : undefined;
        const { sqSize, viewBox, radius, strokeWidth, dashArray, resetOffset } = this.getSvgProperties(percentage);
        return (h(Host, { key: '9b8f3258255641e6f2a347337c6c78317871c0e8' }, this.type === 'circular' && (h("svg", { key: 'e9e656f2ae5155036e79a3bb0b19e8676b5669cc', height: sqSize, viewBox: viewBox }, h("title", { key: 'e2f80812c79d44f48c29034b0839d1b64964769f' }, "Progress indicator"), h("circle", { key: '0d2039ab054480714168f154cc13d57398544678', class: "circle-background", cx: sqSize / 2, cy: sqSize / 2, r: radius, "stroke-width": `${strokeWidth}px` }), h("circle", { key: 'dbd0f3bf1fcac1c3f1a3bef1c1361a1366af20fa', class: ['circle-progress', this.progressBackground].filter(Boolean).join(' '), cx: sqSize / 2, cy: sqSize / 2, r: radius, "stroke-width": `${strokeWidth}px`, transform: `rotate(${ -90 + strokeWidth} ${sqSize / 2} ${sqSize / 2})`, style: { strokeDasharray: `${dashArray}`, strokeDashoffset: `${resetOffset}` } }))), this.type === 'linear' && (h("div", { key: 'cdd0dfc77b1f9cdf428680314e42a145e329684c', class: ['linear-fill', this.progressBackground].filter(Boolean).join(' '), style: width }))));
    }
    static get style() { return progressBarCss; }
}, [257, "wui-progress-bar", {
        "type": [513],
        "progressValue": [2, "progress-value"],
        "indeterminate": [516],
        "progressBackground": [513, "progress-background"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-progress-bar"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-progress-bar":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiProgressBar);
            }
            break;
    } });
}
defineCustomElement();

export { WuiProgressBar as W, defineCustomElement as d };
